import NiceModal from '@ebay/nice-modal-react';
export const ModalsProvider = ({ children }) => {
  return (
    <NiceModal.Provider>
      {children}
    </NiceModal.Provider>
  );
};
